import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import {GraphPushAutoInit} from './components/GraphPushAutoInit'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AndreiChatProvider } from './contexts/AndreiChatContext'
import AndreiChatPanel from './themes/terminal/AndreiChatPanel'
import { ApprovalsProvider } from './contexts/ApprovalsContext'
import ApprovalsPanel from './components/ApprovalsPanel'
// Built-in named theme styles — each file is scoped to [data-app-theme="<slug>"]
// on <html> and only activates when that theme is selected via the switcher.
import './themes/terminal/global.scss'
import './themes/graphite/global.scss'
import './themes/graphite/panels.scss'
import './themes/graphite/job-workspace.scss'
import './themes/graphite/mail.scss'
import './themes/graphite/agent-access.scss'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AndreiChatProvider>
           <ApprovalsProvider>
            <GraphPushAutoInit />
            <Outlet />
            <MasterInit />
            {/* Mounted at app level so any page can call useAndreiChat()
                .openAndreiChat({context, prefill}) and the panel slides in
                with the right context attached. */}
            <AndreiChatPanel />
            {/* Unified approvals inbox — global side-pane fed by ApprovalsContext;
                opened from the header "approve" badge in either theme. */}
            <ApprovalsPanel />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              style={{ zIndex: 9999 }}
            />
           </ApprovalsProvider>
          </AndreiChatProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export { App }